import gelleryOperations from "@/hooks/Gallery/gallery.gql"
import {
  getScrollHeight, getScrollTop, getWindowHeight 
} from "@/util/scroll"
import mergeOperations from "@/util/shallowMerge"
import {
  useLazyQuery, useQuery 
} from "@apollo/client"
import {
  useCallback, useEffect, useState 
} from "react"
import DEFAULT_OPERATIONS from "./realWeddingPage.gql"
const throttle = require("lodash.throttle")

const pageSize = 20

export const useRealWeddingPage = (props) => {
  const operations = mergeOperations(
    DEFAULT_OPERATIONS,
    gelleryOperations,
    props.operations
  )

  const {
    getRealWeddingPageQuery, getStoreConfigQuery 
  } = operations

  const [currentPage, setCurrentPage] = useState(1)

  const [colors, setColors] = useState([])

  const [selectedColorIds, setSelectedColorIds] = useState("")

  const [categories, setCategories] = useState([])

  const [selectedCategoryId, setSelectedCategoryId] = useState("")

  const [itemModalVisible, setItemModalVisible] = useState(false)

  const [items, setItems] = useState([])

  const [totalPage, setTotalPage] = useState(null)

  const [selectedItem, setSelectedItem] = useState(null)

  const [fetchRealWedding, {
    called, data, loading 
  }] = useLazyQuery(
    getRealWeddingPageQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  )

  useEffect(() => {
    const variables = {
      currentPage, pageSize 
    }

    if (selectedColorIds) {
      variables["color_id"] = selectedColorIds
    }

    if (selectedCategoryId) {
      variables["category_id"] = selectedCategoryId
    }

    fetchRealWedding({
      variables,
    })
  }, [currentPage, selectedColorIds, selectedCategoryId, fetchRealWedding])

  const {
    data: storeConfigData 
  } = useQuery(getStoreConfigQuery, {
    fetchPolicy: "cache-and-network",
  })

  const storeConfig = storeConfigData ? storeConfigData.storeConfig : null

  useEffect(() => {
    setItems([])
    setCurrentPage(1)
  }, [selectedColorIds, selectedCategoryId])

  useEffect(() => {
    if (!data) { return }

    const {
      categories, items, colors, page_info 
    } = data.allRealWedding

    setCategories(categories)
    setItems((preItems) => preItems.concat(items))
    setColors(colors)
    setTotalPage(page_info.total_pages)
  }, [data, setCategories, setItems, setColors])

  useEffect(() => {
    const onScroll = throttle((loading, totalPage, currentPage) => {
      if (loading) {
        return
      }

      if (totalPage && currentPage >= totalPage) {
        return
      }

      if (getScrollTop() + getWindowHeight() + 100 > getScrollHeight()) {
        setCurrentPage((currentPage) => currentPage + 1)
      }
    }, 1000)

    const onScrollCallback = () => {
      onScroll(loading, totalPage, currentPage)
    }

    window.addEventListener("scroll", onScrollCallback)

    return () => {
      window.removeEventListener("scroll", onScrollCallback)
    }
  }, [loading, totalPage, currentPage])

  const onClose = useCallback(() => {
    setItemModalVisible(false)
  }, [setItemModalVisible])

  return {
    colors,
    selectedColorIds,
    setSelectedColorIds,
    categories,
    selectedCategoryId,
    setSelectedCategoryId,
    items,
    itemModalVisible,
    setItemModalVisible,
    selectedItem,
    storeConfig,
    setSelectedItem,
    onClose,
    loading,
  }
}
